var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u96aq9aw9a",
    x1: 0.5,
    y1: 0.379,
    x2: -0.078,
    y2: 1.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8bf05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806202"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 26",
    d: "M26.183 3.957a2 2 0 0 1 3.635 0l5.972 13a2 2 0 0 0 1.59 1.152l14.256 1.632a2 2 0 0 1 1.122 3.463L42.2 32.855a2 2 0 0 0-.611 1.875l2.844 13.989a2 2 0 0 1-2.933 2.142l-12.521-7.029a2 2 0 0 0-1.959 0L14.5 50.861a2 2 0 0 1-2.939-2.142l2.844-13.989a2 2 0 0 0-.611-1.875L3.243 23.208a2 2 0 0 1 1.122-3.463l14.255-1.633a2 2 0 0 0 1.59-1.152z",
    style: {
      fill: "url(#u96aq9aw9a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/goldIcon.fbb32dfba35bcd9921de4747b8391c85.svg";
export { ForwardRef as ReactComponent };